<template>
  <Card extra-classes="bg-white px-4 py-5 sm:px-6">
    <div class="flex justify-between">
      <h2 id="referrals-title" class="text-lg font-medium text-gray-900">Referrals</h2>
    </div>
    <div class="mt-6 flow-root">
      <ul v-if="contact.referrals.length > 0" role="list" class="-mb-8">
        <li v-for="referral of contact.referrals" :key="referral.id">
          <div class="relative pb-8">
            <span class="absolute top-4 left-4 -ml-px h-full w-0.5" aria-hidden="true"></span>
            <div class="relative flex space-x-3">
              <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                <div>
                  <router-link
                    :to="`/contacts/${referral.id}`"
                    class="text-sm leading-5 font-medium text-indigo-600 hover:text-indigo-900"
                  >
                    {{ referral.name }}
                    <span
                      v-if="referral.stage == 'Hired'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ referral.stage }}
                    </span>
                    <span
                      v-else-if="referral.stage == 'Disqualified'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ referral.stage }}
                    </span>
                    <span
                      v-else
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ referral.stage }}
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="text-sm text-gray-500">
              {{ formatDate(referral.created_at, 'MMMM dd yyyy, h:mm a') }}
            </div>
          </div>
        </li>
      </ul>
      <div v-else class="text-sm text-gray-500">
        No referrals yet, reach out to your account manager to see how you can easily get your team to refer you more
        agents using their unique link on social media.
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '../Card/index.vue';
import DateUtility from '../../utilities/dates';

export default {
  props: ['contact'],
  components: {
    Card,
  },
  methods: {
    ...DateUtility,
  },
};
</script>
